import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  // namespaced: true,
  state: {
    kits: [],
    kit: {},
  },
  mutations: {
    kits(state, kits) {
      state.kits = kits;
    },
    kit(state, kit) {
      state.kit = kit;
    }
  },
}
